import { useState } from 'react';
import { API_CONFIG } from '../../common/api';

export default function Contatti() {
  const [form, setForm] = useState({ nome: '', email: '', telefono: '', messaggio: '' });
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);
  const [sendError, setSendError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.nome.trim()) e.nome = 'Il nome è obbligatorio';
    if (!form.email.trim()) {
      e.email = "L'email è obbligatoria";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      e.email = 'Email non valida';
    }
    if (form.telefono.trim() && !/^[\d\s\+\-\.\(\)]{6,20}$/.test(form.telefono.trim())) {
      e.telefono = 'Numero di telefono non valido';
    }
    if (!form.messaggio.trim()) e.messaggio = 'Il messaggio è obbligatorio';
    return e;
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors((prev) => ({ ...prev, [e.target.name]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setSubmitting(true);
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/api/richieste-contatto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          nome: form.nome,
          email: form.email,
          telefono: form.telefono || null,
          messaggio: form.messaggio,
          sorgente: 'contatti',
        }),
      });
      if (!response.ok) throw new Error('Errore server');
      setSent(true);
    } catch (_) {
      setSendError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFEFA] py-16 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-gray-800 mb-3">Contattaci</h1>
          <p className="text-gray-500 text-lg">
            Hai domande o vuoi saperne di più? Scrivici, ti risponderemo al più presto.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl border border-amber-100 p-8 md:p-12">
          {sent ? (
            <div className="text-center py-10">
              <div className="text-5xl mb-4">✅</div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Messaggio inviato!</h3>
              <p className="text-gray-500">
                Grazie per averci scritto. Ti risponderemo entro 24–48 ore lavorative.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              {sendError && (
                <div className="mb-5 p-4 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm">
                  Si è verificato un errore. Riprova tra qualche istante.
                </div>
              )}

              <div className="mb-5">
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Nome e cognome <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="nome"
                  value={form.nome}
                  onChange={handleChange}
                  className={`w-full px-4 py-3 rounded-xl border text-sm outline-none transition-all
                    ${errors.nome ? 'border-red-400 bg-red-50' : 'border-gray-200 focus:border-[#c78244] focus:ring-2 focus:ring-[#c78244]/20'}`}
                  placeholder="Mario Rossi"
                />
                {errors.nome && <p className="mt-1 text-xs text-red-500">{errors.nome}</p>}
              </div>

              <div className="mb-5">
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className={`w-full px-4 py-3 rounded-xl border text-sm outline-none transition-all
                    ${errors.email ? 'border-red-400 bg-red-50' : 'border-gray-200 focus:border-[#c78244] focus:ring-2 focus:ring-[#c78244]/20'}`}
                  placeholder="mario@esempio.it"
                />
                {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email}</p>}
              </div>

              <div className="mb-5">
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Telefono <span className="text-gray-400 font-normal">(opzionale)</span>
                </label>
                <input
                  type="tel"
                  name="telefono"
                  value={form.telefono}
                  onChange={handleChange}
                  className={`w-full px-4 py-3 rounded-xl border text-sm outline-none transition-all
                    ${errors.telefono ? 'border-red-400 bg-red-50' : 'border-gray-200 focus:border-[#c78244] focus:ring-2 focus:ring-[#c78244]/20'}`}
                  placeholder="+39 333 1234567"
                />
                {errors.telefono && <p className="mt-1 text-xs text-red-500">{errors.telefono}</p>}
              </div>

              <div className="mb-7">
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Messaggio <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="messaggio"
                  value={form.messaggio}
                  onChange={handleChange}
                  rows={5}
                  className={`w-full px-4 py-3 rounded-xl border text-sm outline-none transition-all resize-none
                    ${errors.messaggio ? 'border-red-400 bg-red-50' : 'border-gray-200 focus:border-[#c78244] focus:ring-2 focus:ring-[#c78244]/20'}`}
                  placeholder="Scrivi qui il tuo messaggio…"
                />
                {errors.messaggio && <p className="mt-1 text-xs text-red-500">{errors.messaggio}</p>}
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="w-full bg-gradient-to-r from-[#F6CF48] to-[#c78244] text-white font-bold py-4 rounded-2xl text-base shadow-lg transition-opacity disabled:opacity-60"
              >
                {submitting ? 'Invio in corso…' : 'Invia messaggio'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
